import { createRouter, createWebHashHistory } from 'vue-router'
import {
  isLogin, saveBatchStockOutContent, saveBatchStockInContent, saveStockOutCountEachContent,
  saveSupplierEachStockOutContent,
  saveShopOrderDetail,
  getStockOutCountEachContent,
  saveBatchStockInStatusContent,
  saveBatchStockOutStatusContent,
  saveWareHouseShowFlag
} from '@/utils/localStorageUtils'
import { load } from '@/utils/appUI.js'

import { useKeepKeyEffect, useReportEffect } from "@/utils/cacheUtils";

import { clearQaStepInfo } from '@/views/qa/partone/useQaFormInfoEffect'
import {
  clearQaStepRedesignInfo,
  shouldPreserveQaRedesignSession,
} from '@/views/qa/partone/useQaFormRedesignEffect'


import Home from '@/views/home/Home.vue'
import HomePc from '@/views/home/HomePc.vue'
import HomePcMapTiler from '@/views/home/HomePcMapTiler.vue'
import HomeMobileMapTiler from '@/views/home/HomeMobileMapTiler.vue'
import HomeMobileMapTilerWithDocker from '@/views/home/HomeMobileMapTilerWithDocker.vue'
// import Mine from '@/views/mine/Mine.vue'
import Mine from '@/views/mine/MineRedesign.vue'
import Scheme from '@/views/scheme/Scheme.vue'

import { WX_OFFICIAL_ACCOUNT } from "@/utils/config.js";



const { clearAllKeepAlive } = useKeepKeyEffect()


const { showReportUI, hideReportUI } = useReportEffect();

const routes = [


  {
    path: '/',
    redirect: { name: 'Mine' },
  },
  {
    path: '/dealer',
    name: 'Dealer',
    component: HomeMobileMapTilerWithDocker,
    meta: { keepAlive: true }, // 需要缓存

  },
  {
    path: '/dealer-mobile',
    name: 'DealerMobile',
    component: HomeMobileMapTiler,
    meta: { keepAlive: true }, // 需要缓存

  },
  {
    path: '/dealer-pc',
    name: 'DealerPc',
    component: HomePcMapTiler,
    meta: { keepAlive: true }, // 需要缓存
  },
  // {
  //   path: '/dealer-pc-maptiler',
  //   name: 'DealerPcMapTiler',
  //   component: HomePcMapTiler,
  //   meta: { keepAlive: true },
  // },
  // {
  //   path: '/dealer-maptiler',
  //   name: 'DealerMapTiler',
  //   component: HomeMobileMapTiler,
  //   meta: { keepAlive: true },
  // },
  {
    path: '/internal/address-geocode',
    name: 'AddressGeocode',
    component: () =>
      import(
        /* webpackChunkName: "address-geocode" */ '@/views/tools/AddressGeocodeTool.vue'
      ),
    meta: { keepAlive: false },
  },
  {
    path: '/scheme',
    name: 'Scheme',
    meta: { keepAlive: true }, // 需要缓存
    component: Scheme

  },
  {
    path: '/mine',
    name: 'Mine',
    component: Mine,
    meta: { keepAlive: true }, // 需要缓存

  },
  {
    path: '/mineredesign',
    name: 'MineRedesign',
    component: () => import(/* webpackChunkName: "mine-redesign" */ '@/views/mine/MineRedesign.vue'),
    meta: { keepAlive: true },
  },
  // === 索赔流程（零售商，独立于既有业务） ===
  {
    path: '/claim',
    name: 'ClaimList',
    component: () => import(/* webpackChunkName: "claim" */ '@/views/claim/ClaimList.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/claim/apply',
    name: 'ClaimApply',
    component: () => import(/* webpackChunkName: "claim" */ '@/views/claim/ClaimApply.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/claim/detail',
    name: 'ClaimDetail',
    component: () => import(/* webpackChunkName: "claim" */ '@/views/claim/ClaimDetail.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/claim/approval',
    name: 'ClaimApproval',
    component: () => import(/* webpackChunkName: "claim" */ '@/views/claim/ClaimApproval.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/claim/approval/detail',
    name: 'ClaimApprovalDetail',
    component: () => import(/* webpackChunkName: "claim" */ '@/views/claim/ClaimApprovalDetail.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/claim/compensation',
    name: 'CompensationList',
    component: () => import(/* webpackChunkName: "claim" */ '@/views/claim/CompensationList.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/claim/compensation/detail',
    name: 'CompensationDetail',
    component: () => import(/* webpackChunkName: "claim" */ '@/views/claim/CompensationDetail.vue'),
    meta: { keepAlive: false },
  },
  // 替换qrcode 
  {
    path: '/qrcode',
    name: 'QrCode',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/qrcode/QrCodeView.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },
  // 替换qrcode 
  // {
  //   path: '/qrcode',
  //   name: 'QrCode',
  //   component: () => import(/* webpackChunkName: "shop" */ '@/views/qrcode/QrCodePrimaryView.vue'),
  //   meta: { keepAlive: false }, // 不需要缓存

  // },

  // QrCodeNextView

  {
    path: '/qrcodeorderstockout',
    name: 'QrCodeOrderStockOut',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/qrcode/QrCodeOrderStockOut.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'StockOut' || from.name == 'StockOrderOut') {
        // 当前从StockOut过来的话 清楚信息
        saveBatchStockOutContent('');
        saveBatchStockOutStatusContent('');// 当前是各个校验的序列号的状态版本
      } else {
      }
      next();
      // !isLogin() ? next({ name: 'Login', query: { redirect: to.name } }) : next();
    }

  },



  {
    path: '/qrcodestockout',
    name: 'QrCodeStockOut',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/qrcode/QrCodeStockOut.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      console.log('QrCodeStockOut to', to)
      console.log('QrCodeStockOut from', from)
      if (from.name == 'StockOut' || from.name == 'StockOrderOut' || from.name == 'StockUnOutSupplierDetail') {
        // 当前从StockOut过来的话 清楚信息
        saveBatchStockOutContent('');
        saveBatchStockOutStatusContent('');// 当前是各个校验的序列号的状态版本
        // saveWareHouseShowFlag(false)
      } else {
      }
      next();
      // !isLogin() ? next({ name: 'Login', query: { redirect: to.name } }) : next();
    }

  },

  {
    path: '/qrcodestockin',
    name: 'QrCodeStockIn',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/qrcode/QrCodeStockIn.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      console.log('QrCodeStockIn to', to)
      console.log('QrCodeStockIn from', from)
      if (from.name == 'StockIn') {
        // 当前从StockOut过来的话 清楚信息
        saveBatchStockInContent('');
        saveBatchStockInStatusContent(''); // 当前是各个校验的序列号的状态版本
        // saveWareHouseShowFlag(false)
      } else {
      }
      next();
      // !isLogin() ? next({ name: 'Login', query: { redirect: to.name } }) : next();
    }

  },




  {
    path: '/schemedetail/:id',
    name: 'SchemeDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/scheme/SchemeDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },




  // {
  //   path: '/qaform',
  //   name: 'QaForm',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qaform/QaForm.vue'),
  //   meta: { keepAlive: false }, // 不需要缓存

  // },

  {
    path: '/qaformtemp',
    name: 'PartOneQaForm',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaForm.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  //todo 最新版的处理  新版的处理
  {
    path: '/qaform',
    name: 'QaForm',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepOneRedesign.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      console.log('QaFormStepOne to', to)
      console.log('QaFormStepOne from', from)
      if (shouldPreserveQaRedesignSession(from.name)) {
        // 从扫码或步骤二/三返回，保留 Redesign session
      } else {
        clearQaStepRedesignInfo();
      }
      next();
      // !isLogin() ? next({ name: 'Login', query: { redirect: to.name } }) : next();
    }
  },
  // 质保 步骤二
  {
    path: '/qaformtwo',
    name: 'QaFormStepTwo',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepTwoRedesign.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 质保 步骤三
  {
    path: '/qaformthree',
    name: 'QaFormStepThree',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepThreeRedesign.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },
  //todo 最新版的处理  新版的处理


  // // 质保 步骤一
  // {
  //   path: '/qaform',
  //   name: 'QaForm',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepOne.vue'),
  //   meta: { keepAlive: false }, // 不需要缓存
  //   beforeEnter(to, from, next) {
  //     console.log('QaFormStepOne to', to)
  //     console.log('QaFormStepOne from', from)
  //     if (from.name == 'QrCode' || from.name == 'QaFormStepTwo') {
  //       // 当前从qrcode 过来的话 就不需要清楚信息 

  //     } else {
  //       // 不是的话 清除
  //       clearQaStepInfo();
  //     }
  //     next();
  //     // !isLogin() ? next({ name: 'Login', query: { redirect: to.name } }) : next();
  //   }
  // },
  // // 质保 步骤二
  // {
  //   path: '/qaformtwo',
  //   name: 'QaFormStepTwo',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepTwo.vue'),
  //   meta: { keepAlive: false }, // 不需要缓存
  // },

  // // 质保 步骤三
  // {
  //   path: '/qaformthree',
  //   name: 'QaFormStepThree',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepThree.vue'),
  //   meta: { keepAlive: false }, // 不需要缓存
  // },

  // === 新版质保流程（交互优化） ===

  // 新版 步骤一
  {
    path: '/qaformnew',
    name: 'QaFormNew',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepOneNew.vue'),
    meta: { keepAlive: false },
    beforeEnter(to, from, next) {
      if (from.name == 'QrCode' || from.name == 'QaFormStepTwoNew') {
        // 从扫码或步骤二返回，保留数据
      } else {
        clearQaStepInfo();
      }
      next();
    },
  },

  // 新版 步骤二
  {
    path: '/qaformtwonew',
    name: 'QaFormStepTwoNew',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepTwoNew.vue'),
    meta: { keepAlive: false },
  },

  // 新版 步骤三
  {
    path: '/qaformthreenew',
    name: 'QaFormStepThreeNew',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepThreeNew.vue'),
    meta: { keepAlive: false },
  },

  // === Redesign 质保流程 Step1（UI/UX 重构，逻辑不变） ===
  {
    path: '/qaformredesign',
    name: 'QaFormStepRedesign',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepOneRedesign.vue'),
    meta: { keepAlive: false },
    beforeEnter(to, from, next) {
      if (shouldPreserveQaRedesignSession(from.name)) {
        // 从扫码或步骤二/三返回，保留 Redesign session
      } else {
        clearQaStepRedesignInfo();
      }
      next();
    },
  },

  // === Redesign 质保流程 Step2（UI/UX 重构，逻辑不变） ===
  {
    path: '/qaformsteptworedesign',
    name: 'QaFormStepTwoRedesign',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepTwoRedesign.vue'),
    meta: { keepAlive: false },
  },

  // === Redesign 质保流程 Step3（UI/UX 重构，逻辑不变） ===
  {
    path: '/qaformstepthreeredesign',
    name: 'QaFormStepThreeRedesign',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/partone/qaform/QaFormStepThreeRedesign.vue'),
    meta: { keepAlive: false },
  },

  // === 纯前端车衣报价（独立入口，无需登录） ===
  {
    path: '/quote',
    alias: '/pricing',
    name: 'PpfQuote',
    component: () => import(/* webpackChunkName: "quote" */ '@/views/quote/QuotePage.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/quote-pc',
    name: 'PpfQuotePc',
    component: () => import(/* webpackChunkName: "quote-pc" */ '@/views/quote/QuotePagePc.vue'),
    meta: { keepAlive: false, fullPage: true },
  },

  // === C 端商品选购下单流程（选购 -> 选规格 -> 下单 -> 支付，纯前端演示，复用 shop 接口 + mock 兜底） ===
  {
    path: '/cshop',
    name: 'CShop',
    component: () => import(/* webpackChunkName: "cshop" */ '@/views/cshop/CShop.vue'),
    meta: { keepAlive: false },
  },

  // === C 端订单管理（我的订单，复用买家订单接口 + mock 兜底） ===
  {
    path: '/corder',
    name: 'COrderList',
    component: () => import(/* webpackChunkName: "corder" */ '@/views/corder/COrderList.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/corder/:id',
    name: 'COrderDetail',
    component: () => import(/* webpackChunkName: "corder" */ '@/views/corder/COrderDetail.vue'),
    meta: { keepAlive: false },
  },

  {
    path: '/qalist',
    name: 'QaList',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qalist/QaListRedesign.vue'),
    // component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qalist/QaList.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },
  {
    path: '/qalistredesign',
    name: 'QaListRedesign',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qalist/QaListRedesign.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/qadetailtemp',
    name: 'QaDetailTemp',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qadetail/QaDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },
  {
    path: '/qadetail',
    name: 'QaDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qadetail/QaNewDetailRedesign.vue'),
    // component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qadetail/QaNewDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },
  {
    path: '/qadetailredesign',
    name: 'QaDetailRedesign',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qadetail/QaNewDetailRedesign.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/qareview',
    name: 'QaReview',
    // component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qareview/QaReview.vue'),
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qareview/QaReviewRedesign.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },
  {
    path: '/qareviewredesign',
    name: 'QaReviewRedesign',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qareview/QaReviewRedesign.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/qasearch',
    name: 'QaSearch',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qasearch/QaSearch.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },
  {
    path: '/qa-public-query',
    name: 'QaPublicQuery',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qapublic/QaPublicQueryRedesign.vue'),
    meta: { keepAlive: true },
  },
  {
    path: '/qa-public-detail',
    name: 'QaPublicDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/qa/qapublic/QaPublicDetailRedesign.vue'),
    meta: { keepAlive: false },
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shop/Shop.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'OrderDetail') {
      } else {
        saveShopOrderDetail('')
        clearAllKeepAlive();
      }
      next();
    }
  },


  // 交易下单的产品界面
  {
    path: '/shoporder/:storeid',
    name: 'ShopOrder',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shoporder/Shop.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'OrderPriceDetail') {
      } else {
        saveShopOrderDetail('')
        clearAllKeepAlive();
      }
      next();
    }
  },

  {
    path: '/shoplisttemp',
    name: 'ShopListTemp',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shop/shoplist/ShopList.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  {
    path: '/shoplist',
    name: 'ShopList',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shop/shoplist/ShopStatusList.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  // 交易订单
  {
    path: '/shoporderlist',
    name: 'ShopOrderList',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shoporder/shoplist/ShopStatusList.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },






  {
    path: '/shopdetailtemp/:id',
    name: 'ShopDetailtemp',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shop/shopdetail/ShopDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },
  {
    path: '/shopdetail/:id',
    name: 'ShopDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shop/shopdetail/ShopStatusDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 交易订单的详情
  {
    path: '/shoporderdetail/:id',
    name: 'ShopOrderDetail',
    // todo pay 
    // component: () => import(/* webpackChunkName: "about" */ '@/views/shoporder/shopdetail/ShopStatusDetail.vue'),
    component: () => import(/* webpackChunkName: "about" */ '@/views/shoporder/shopdetail/ShopStatusDetailV2.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  {
    path: '/stocktemp',
    name: 'StockTemp',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/Stock.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  {
    path: '/stockin',
    name: 'StockIn',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/in/StockIn.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'StockUnInDetail' || from.name == 'QrCodeStockIn' || from.name == 'StockUnInRecordDetail' || from.name == 'StockUnInStockDetail' || from.name == 'WareHouseCreate') {
      } else {
        clearAllKeepAlive();
      }
      saveWareHouseShowFlag(false) // 清楚一下仓库展示的状态

      next();
    }


  },


  {
    path: '/stockout',
    name: 'StockOut',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/out/StockOut.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'StockUnOutDetail' || from.name == 'QrCodeStockOut' || from.name == 'StockUnOutRecordDetail' || from.name == 'StockUnOutStockDetail' || from.name == 'StockUnOutSupplierDetail') {
        // 当前从StockOut过来的话 清楚信息
        // saveBatchStockOutContent('');
      } else {
        clearAllKeepAlive();
      }
      saveWareHouseShowFlag(false) // 清楚一下仓库展示的状态
      next();
    }

  },


  {
    path: '/stockorderout/:id',
    name: 'StockOrderOut',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/orderout/StockOut.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'StockUnOutDetail' || from.name == 'QrCodeStockOut' || from.name == 'StockUnOutRecordDetail' || from.name == 'StockUnOutStockDetail' || from.name == 'StockOrderUnOutDetail') {
        // 当前从StockOut过来的话 清楚信息
        // saveBatchStockOutContent('');
      } else {
        clearAllKeepAlive();
      }

      next();
    }

  },

  {
    path: '/supplierstockout/:id',
    // path: '/supplierstockout',
    name: 'SupplierStockOut',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/orderout/supplierstore/SupplierStockOut.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      // todo 哪些需要清楚的 稍等再看看
      // if (from.name == 'StockUnOutDetail' || from.name == 'QrCodeStockOut' || from.name == 'StockUnOutRecordDetail' || from.name == 'StockUnOutStockDetail' || from.name == 'StockOrderUnOutDetail') {
      //   // 当前从StockOut过来的话 清楚信息
      //   // saveBatchStockOutContent('');
      // } else {
      //   clearAllKeepAlive();
      // }

      next();
    }

  },








  {
    path: '/stockoutconfirm',
    name: 'StockOutConfirm',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/out/StockOutConfirm.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  {
    path: '/stockorderoutconfirm',
    name: 'StockOrderOutConfirm',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/orderout/StockOutConfirm.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  // {
  //   path: '/shopstockoutconfirm',
  //   name: 'ShopStockOutConfirm',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/stock/orderout/StockOutConfirm.vue'),
  //   meta: { keepAlive: false }, // 不需要缓存

  // },

  {
    path: '/stockinconfirm',
    name: 'StockInConfirm',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/in/StockInConfirm.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },



  {
    path: '/stockunindetail',
    name: 'StockUnInDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/in/detail/StockUnInDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  {
    path: '/stockuninrecorddetail',
    name: 'StockUnInRecordDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/in/detail/StockUnInRecordDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  {
    path: '/stockuninstockdetail',
    name: 'StockUnInStockDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/in/detail/StockUnInStockDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },





  {
    path: '/stockunoutdetail',
    name: 'StockUnOutDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/out/detail/StockUnOutDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'StockOut' || from.name == 'StockOrderOut') {
        // 当前从StockOut过来的话 清楚信息
        saveStockOutCountEachContent('');
      } else {
      }
      next();
    }

  },


  {
    path: '/stockunoutsupplierdetail',
    name: 'StockUnOutSupplierDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/out/detail/StockUnOutSupplierDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'StockOut' || from.name == 'StockOrderOut') {
        // 当前从StockOut过来的话 清楚信息
        saveSupplierEachStockOutContent('');
      } else {
      }
      next();
    }

  },

  {
    path: '/stockorderunoutdetail',
    name: 'StockOrderUnOutDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/orderout/detail/StockUnOutDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'StockOut' || from.name == 'StockOrderOut') {
        // 当前从StockOut过来的话 清楚信息
        saveStockOutCountEachContent('');
      } else {
      }
      next();
    }

  },


  {
    path: '/stockunoutrecorddetail',
    name: 'StockUnOutRecordDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/out/detail/StockUnOutRecordDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  {
    path: '/stockunoutstockdetail',
    name: 'StockUnOutStockDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/stock/out/detail/StockUnOutStockDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },







  {
    path: '/purchaseordertemp',
    name: 'PurchaseOrderTemp',
    component: () => import(/* webpackChunkName: "about" */ '@/views/purchaseorder/PurchaseOrder.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },
  {
    path: '/purchaseorder',
    name: 'PurchaseOrder',
    component: () => import(/* webpackChunkName: "about" */ '@/views/purchaseorder/PurchaseStatusOrder.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },



  // 交易订单管理
  {
    path: '/paymentorder',
    name: 'PaymentOrder',
    component: () => import(/* webpackChunkName: "about" */ '@/views/paymentorder/PaymentOrder.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 付款单管理
  {
    path: '/paymentbillmanage',
    name: 'PaymentBillManage',
    component: () => import(/* webpackChunkName: "about" */ '@/views/paymentorder/paymentbill/PaymentBillManage.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  // 付款单管理(买方)
  {
    path: '/paymentbillmanagebuyer',
    name: 'PaymentBillManageBuyer',
    component: () => import(/* webpackChunkName: "about" */ '@/views/paymentorder/paymentbill/buyer/PaymentBillManageBuyer.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },



  {
    path: '/storelist',
    name: 'StoreList',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shoporder/store/StoreList.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },



  {
    path: '/storemanagerlist',
    name: 'StoreManagerList',
    component: () => import(/* webpackChunkName: "about" */ '@/views/store/StoreManagerList.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },




  {
    path: '/storedetail/:storeid',
    name: 'StoreDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/store/detail/StoreDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },








  {
    path: '/purchaseorderdetailtemp/:id',
    name: 'PurchaseOrderDetailtemp',
    component: () => import(/* webpackChunkName: "about" */ '@/views/purchaseorder/PurchaseOrderDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },
  {
    path: '/purchaseorderdetail/:id',
    name: 'PurchaseOrderDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/purchaseorder/PurchaseOrderStatusDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  {
    path: '/paymentorderdetail/:id',
    name: 'PaymentOrderDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/paymentorder/PaymentOrderStatusDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  {
    path: '/paymentorderbilldetail/:id',
    name: 'PaymentOrderBillDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/paymentorder/paymentbill/PaymentOrderBillDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  {
    path: '/paymentorderbilldetailbuyer/:id',
    name: 'PaymentOrderBillDetailBuyer',
    component: () => import(/* webpackChunkName: "about" */ '@/views/paymentorder/paymentbill/buyer/PaymentOrderBillDetailBuyer.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  {
    path: '/orderdetail',
    name: 'OrderDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shop/orderdetail/OrderDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  {
    path: '/orderpricedetail/:storeid',
    name: 'OrderPriceDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/shoporder/orderdetail/OrderDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 消费者扫码订单详情（个人消费者，扫码进入）
  {
    path: '/consumer/orderdetail',
    name: 'ConsumerOrderDetail',
    component: () => import(/* webpackChunkName: "consumer" */ '@/views/consumer/orderdetail/ConsumerOrderDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 消费者零售商选择（本站选品入口，选完进入商品选择页）
  {
    path: '/consumer/retailer',
    name: 'ConsumerRetailerList',
    component: () => import(/* webpackChunkName: "consumer" */ '@/views/consumer/shop/ConsumerStoreList.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 消费者商品/SKU 选择（本站选品，选完携带购物车数据进入订单详情）
  {
    path: '/consumer/product',
    name: 'ConsumerProductSelect',
    component: () => import(/* webpackChunkName: "consumer" */ '@/views/consumer/shop/ConsumerShop.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 消费者订单列表
  {
    path: '/consumer/order/list',
    name: 'ConsumerOrderList',
    component: () => import(/* webpackChunkName: "consumer" */ '@/views/consumer/order/ConsumerOrderList.vue'),
    meta: { keepAlive: true }, // 缓存，返回列表不刷新
  },

  // 消费者订单详情
  {
    path: '/consumer/order/info/:id',
    name: 'ConsumerOrderInfo',
    component: () => import(/* webpackChunkName: "consumer" */ '@/views/consumer/order/ConsumerOrderInfo.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 消费者付款单管理
  {
    path: '/consumer/paymentbill/list',
    name: 'ConsumerPaymentBillList',
    component: () => import(/* webpackChunkName: "consumer" */ '@/views/consumer/paymentbill/ConsumerPaymentBillList.vue'),
    meta: { keepAlive: true }, // 缓存，返回列表不刷新
  },

  // 消费者付款单详情
  {
    path: '/consumer/paymentbill/info/:id',
    name: 'ConsumerPaymentBillDetail',
    component: () => import(/* webpackChunkName: "consumer" */ '@/views/consumer/paymentbill/ConsumerPaymentBillDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  {
    path: '/oldlogin',
    name: 'OldLogin',
    component: () => import(/* webpackChunkName: "about" */ '@/views/login/Login.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 新版本的 login
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '@/views/login/RoleLogin.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  {
    path: '/dealerregister',
    name: 'DealerRegister',
    component: () => import(/* webpackChunkName: "about" */ '@/views/register/DealerRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存


  },
  {
    path: '/dealeruserregister',
    name: 'DealerUserRegister',
    component: () => import(/* webpackChunkName: "about" */ '@/views/register/DealerUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  {
    path: '/userregister',
    name: 'UserRegister',
    component: () => import(/* webpackChunkName: "about" */ '@/views/register/UserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存


  },

  {
    path: '/changelanguage',
    name: 'ChangeLanguage',
    component: () => import(/* webpackChunkName: "about" */ '@/views/language/ChangeLanguage.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  //报表的路由页面
  {
    path: '/proxychart',
    name: 'ProxyChart',
    component: () => import(/* webpackChunkName: "about" */ '@/views/charts/proxy/ProxyChart.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  //质保报表
  {
    path: '/qachart',
    name: 'QaChart',
    component: () => import(/* webpackChunkName: "about" */ '@/views/charts/qa/QaChart.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      // 进入到报表的话 需要处理一点状态
      showReportUI();
      next();
    }

  },
  //采购单报表
  {
    path: '/porderchart',
    name: 'PurchaseOrderChart',
    component: () => import(/* webpackChunkName: "about" */ '@/views/charts/order/PurchaseOrderChart.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      // 进入到报表的话 需要处理一点状态
      showReportUI();
      next();
    }
  },

  //出入库报表
  {
    path: '/inoutstockchart',
    name: 'InOutStockChart',
    component: () => import(/* webpackChunkName: "about" */ '@/views/charts/stock/InOutStockChart.vue'),
    meta: { keepAlive: false }, // 不需要缓存
    beforeEnter(to, from, next) {
      // 进入到报表的话 需要处理一点状态
      showReportUI();
      next();
    }
  },


  // 防伪查询
  {
    path: '/securitycheck',
    name: 'SecurityCheck',
    component: () => import(/* webpackChunkName: "about" */ '@/views/security/SecurityCheck.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  // 代理商
  {
    path: '/dealershopmanager',
    name: 'DealerShopManager',
    component: () => import(/* webpackChunkName: "about" */ '@/views/dealer/DealerShopManager.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  // 直营商 店铺创建 
  {
    path: '/directvendormanager',
    name: 'DirectVendorManager',
    component: () => import(/* webpackChunkName: "about" */ '@/views/directvendor/DirectVendorManager.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  // 代理商详情
  {
    path: '/dealerdetail',
    name: 'DealerDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/dealer/dealerdetail/DealerDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  // 门店创建
  {
    path: '/createshop',
    name: 'CreateShop',
    component: () => import(/* webpackChunkName: "about" */ '@/views/dealer/shop/CreateShop.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  // 经销商创建
  {
    path: '/createdealer',
    name: 'CreateDealer',
    component: () => import(/* webpackChunkName: "about" */ '@/views/dealer/dealer/CreateDealer.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  // 我的券码
  {
    path: '/coupon',
    name: 'Coupon',
    component: () => import(/* webpackChunkName: "about" */ '@/views/coupon/Coupon.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 券码管理
  {
    path: '/dealercoupon',
    name: 'DealerCoupon',
    component: () => import(/* webpackChunkName: "about" */ '@/views/coupon/dealercoupon/Coupon.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 券码详情
  {
    path: '/coupondetail',
    name: 'CouponDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/coupon/detail/CouponDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 经销商券码详情
  {
    path: '/dealercoupondetail',
    name: 'DealerCouponDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/coupon/detail/dealerdetail/CouponDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },



  // 券码核销
  {
    path: '/couponscan',
    name: 'CouponScan',
    component: () => import(/* webpackChunkName: "about" */ '@/views/coupon/scan/CouponScan.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },



  // 券码核销记录
  {
    path: '/couponscandetail',
    name: 'CouponScanDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/coupon/scan/detail/CouponScanDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  // 券码核销记录
  {
    path: '/couponscaninfodetail',
    name: 'CouponScanInfoDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/coupon/scan/scandetail/CouponScanInfoDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },



  // 员工管理
  {
    path: '/workerlist',
    name: 'WorkerList',
    component: () => import(/* webpackChunkName: "about" */ '@/views/worker/WorkerList.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  // 员工详情
  {
    path: '/workerdetail',
    name: 'WorkerDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/worker/detail/WorkerDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },










  // 施工单
  {
    path: '/construction',
    name: 'Construction',
    component: () => import(/* webpackChunkName: "about" */ '@/views/construction/Construction.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 待施工
  {
    path: '/constructionpending',
    name: 'ConstructionPending',
    component: () => import(/* webpackChunkName: "about" */ '@/views/construction/status/ConstructionPending.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  // 施工完成页面
  {
    path: '/constructioncompleted',
    name: 'ConstructionCompleted',
    component: () => import(/* webpackChunkName: "about" */ '@/views/construction/status/ConstructionCompleted.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  // 施工验收页面
  {
    path: '/constructionorderaccepted',
    name: 'ConstructionOrderAccepted',
    component: () => import(/* webpackChunkName: "about" */ '@/views/construction/status/ConstructionOrderAccepted.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  // 施工单详情页面
  {
    path: '/constructiondetail',
    name: 'ConstructionDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/construction/detail/ConstructionDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  // 说明书
  {
    path: '/instruction',
    name: 'Instruction',
    component: () => import(/* webpackChunkName: "about" */ '@/views/instruction/Instruction.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },



  // markdown
  {
    path: '/vditor',
    name: 'MarkDown',
    component: () => import(/* webpackChunkName: "about" */ '@/views/markdown/MarkDown.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },


  // markdown
  {
    path: '/ppt',
    name: 'Ppt',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ppt/Ppt.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },






  /********* 报表相关/*********/

  // 券码相关
  {
    path: '/chartscoupon',
    name: 'ChartsCoupon',
    component: () => import(/* webpackChunkName: "about" */ '@/views/charts/coupon/Coupon.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },

  /********* 报表相关/*********/



  /************************************改版 1.0.0 *********************************************/


  /********* 用户选择角色/*********/
  {
    path: '/roleselect',
    name: 'RoleSelect',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/RoleSelect.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  // 登录以后选择角色
  {
    path: '/loginroleselect',
    name: 'LoginRoleSelect',
    // component: () => import(/* webpackChunkName: "shop" */ '@/views/login/LoginRoleSelect.vue'),
    component: () => import(/* webpackChunkName: "shop" */ '@/views/login/LoginRoleSelectRedesign.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  // 登录以后选择角色（Redesign）
  {
    path: '/loginroleselectredesign',
    name: 'LoginRoleSelectRedesign',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/login/LoginRoleSelectRedesign.vue'),
    meta: { keepAlive: false },

  },

  // 直接选择角色
  {
    path: '/mineroleselect',
    name: 'MineRoleSelect',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/mine/MineRoleSelect.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  /********* 用户选择角色/*********/



  /********* 经销商主体注册/*********/
  {
    path: '/mainbodydealernameregister',
    name: 'MainBodyDealerNameRegister',
    alias: '/distributor/tier1/register',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/name/MainBodyDealerNameRegister.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'RoleSelect') {
        // 从角色选择里过来就直接清空
        clearAllKeepAlive();
      }
      next();
    }


  },


  // 一级经销商
  {
    path: '/mainbodydealerregister',
    name: 'MainBodyDealerRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/MainBodyDealerRegister.vue'),
    meta: { keepAlive: true },

  },

  // 直营商
  {
    path: '/mainbodydirectvendorregister',
    name: 'MainBodyDirectVendorRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/MainBodyDirectVendorRegister.vue'),
    meta: { keepAlive: true },

  },



  // 下级经销商
  {
    path: '/mainbodynextdealerregister',
    name: 'MainBodyNextDealerRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/MainBodyNextDealerRegister.vue'),
    meta: { keepAlive: true }, // 不需要缓存

  },


  // 下级经销商名称
  {
    path: '/mainbodynextdealernameregister',
    name: 'MainBodyNextDealerNameRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/name/MainBodyNextDealerNameRegister.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      console.log('from', from)
      if (!from.name) {
        clearAllKeepAlive();
      }
      next();
    }

  },


  // 零售商名称
  {
    path: '/mainbodydealershopnameregister',
    name: 'MainBodyDealerShopNameRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/name/MainBodyDealerShopNameRegister.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      console.log('from', from)
      if (!from.name) {
        clearAllKeepAlive();
      }
      next();
    }

  },


  // 服务商名称
  {
    path: '/mainbodyservicenameregister',
    name: 'MainBodyServiceNameRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/name/MainBodyServiceNameRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  // 零售商
  {
    path: '/mainbodydealershopregister',
    name: 'MainBodyDealerShopRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/MainBodyDealerShopRegister.vue'),
    meta: { keepAlive: true }, // 不需要缓存

  },

  {
    path: '/registeraddressmappicker',
    name: 'RegisterAddressMapPicker',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/RegisterAddressMapPickerEntry.vue'),
    meta: { keepAlive: false },
  },


  // 服务商
  {
    path: '/mainbodyserviceregister',
    name: 'MainBodyServiceRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/MainBodyServiceRegister.vue'),
    meta: { keepAlive: true }, // 不需要缓存

  },


  // 直营商名称
  {
    path: '/mainbodydirectvendornameregister',
    name: 'MainBodyDirectVendorNameRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/name/MainBodyDirectVendorNameRegister.vue'),
    meta: { keepAlive: true }, // 不需要缓存
    beforeEnter(to, from, next) {
      if (from.name == 'RoleSelect') {
        // 从角色选择里过来就直接清空
        clearAllKeepAlive();
      }
      next();
    }

  },






  {
    path: '/mainbodydealeruserregister',
    name: 'MainBodyDealerUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/user/MainBodyDealerUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  {
    path: '/mainbodydirectvendoruserregister',
    name: 'MainBodyDirectVendorUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/user/MainBodDirectVendorUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  {
    path: '/mainbodynextdealeruserregister',
    name: 'MainBodyNextDealerUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/user/MainBodyNextDealerUserRegister.vue'),
    meta: { keepAlive: true }, // 不需要缓存

  },


  // 零售商的第一位用户注册
  {
    path: '/mainbodydealershopuserregister',
    name: 'MainBodyDealerShopUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/user/MainBodyDealerShopUserRegister.vue'),
    meta: { keepAlive: true }, // 不需要缓存

  },

  // 服务商的第一位用户注册
  {
    path: '/mainbodyserviceuserregister',
    name: 'MainBodyServiceUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/company/user/MainBodyServiceUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  // 生成的二维码
  {
    path: '/qrcoderegister',
    name: 'QrCodeRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/qrcode/QrCodeRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },




  /********* 经销商主体注册/*********/


  /********* 报表*********/

  {
    path: '/chartslist',
    name: 'ChartsList',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/charts/ChartsList.vue'),
    meta: { keepAlive: false }, // 不需要缓存
  },




  /********* 报表*********/




  /********* 员工注册/*********/

  // 经销商员工注册
  {
    path: '/qrcodedealeruserregister',
    name: 'QrCodeDealerUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/user/QrCodeDealerUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  // 供应商员工注册
  {
    path: '/qrcodesupplieruserregister',
    name: 'QrCodeSupplierUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/user/QrCodeSupplierUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  // 直营商员工注册
  {
    path: '/qrcodedirectvendoruserregister',
    name: 'QrCodeDirectVendorUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/user/QrCodeDirectVendorUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },





  // 服务商员工注册
  {
    path: '/qrcodeserviceuserregister',
    name: 'QrCodeServiceUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/user/QrCodeServiceUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  // 零售商员工注册
  {
    path: '/qrcodeshopuserregister',
    name: 'QrCodeShopUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/user/QrCodeShopUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },



  // 用户注册
  {
    path: '/consumeruserregister',
    name: 'ConsumerUserRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/user/ConsumerUserRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },



  // 游离的服务人员注册
  {
    path: '/serviceproviderregister',
    name: 'ServiceProviderRegister',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/register/user/ServiceProviderRegister.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },








  /********* 员工注册/*********/






  /************************************改版 1.0.0 *********************************************/



  /********* 服务相关/*********/

  // 服务网点list
  {
    path: '/servicecenterlist',
    name: 'ServiceCenterList',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/service/servicecenter/list/ServiceCenterList.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  // 服务网点创建
  {
    path: '/servicecentercreate',
    name: 'ServiceCenterCreate',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/service/servicecenter/create/ServiceCenterCreate.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  // 服务网点详情
  {
    path: '/servicecenterdetail/:id',
    name: 'ServiceCenterDetail',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/service/servicecenter/detail/ServiceCenterDetail.vue'),
    meta: {
      keepAlive: false
    }, // 不需要缓存

  },




  /********* 服务相关/*********/




  /********* 仓库相关/*********/

  // 仓库list
  {
    path: '/warehouselist',
    name: 'WareHouseList',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/warehouse/list/WareHouseList.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },



  // 仓库创建
  {
    path: '/warehousecreate',
    name: 'WareHouseCreate',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/warehouse/create/WareHouseCreate.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  // 仓库详情
  {
    path: '/warehousedetail/:id',
    name: 'WareHouseDetail',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/warehouse/detail/WareHouseDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },




  /********* 仓库相关/*********/




  /********* 地址相关/*********/

  // 地址list
  {
    path: '/addresslist',
    name: 'AddressList',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/address/list/AddressList.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },



  // 地址创建
  {
    path: '/addresscreate',
    name: 'AddressCreate',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/address/create/AddressCreate.vue'),
    meta: { keepAlive: true },

  },


  // 地址详情
  {
    path: '/addressdetail/:id',
    name: 'AddressDetail',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/address/detail/AddressDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },

  /********* 地址相关/*********/



  /********* 仓库相关/*********/

  // 仓库list
  {
    path: '/warehouselist',
    name: 'WareHouseList',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/warehouse/list/WareHouseList.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },



  // 仓库创建
  {
    path: '/warehousecreate',
    name: 'WareHouseCreate',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/warehouse/create/WareHouseCreate.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },



  // 仓库详情
  {
    path: '/warehousedetail/:id',
    name: 'WareHouseDetail',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/warehouse/detail/WareHouseDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },









  /********* 仓库相关/*********/



  // 查询产品订单汇总
  {
    path: '/productordersummary',
    name: 'ProductOrderSummary',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/productordersummary/ProductOrderSummary.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  // 供应商相关

  {
    path: '/stockcreate',
    name: 'StockCreate',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/stock/create/StockCreate.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },


  {
    path: '/stockdetail',
    name: 'StockDetail',
    component: () => import(/* webpackChunkName: "shop" */ '@/views/stock/create/stockdetail/StockDetail.vue'),
    meta: { keepAlive: false }, // 不需要缓存

  },



  {
    path: '/page1',
    component: () => import('@/views/cache/Page1.vue'),
    name: 'Page1',
    meta: { keepAlive: false }, // 不需要缓存
  },
  {
    path: '/page2',
    component: () => import('@/views/cache/Page2.vue'),
    name: 'Page2',
    meta: { keepAlive: false }, // 不需要缓存
  },


]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// const allRoutes = router.getRoutes()
// console.log('yyyyyy', allRoutes)


// export const changeQaStepKeepAlive = () => {
//   routes.forEach(item => {
//     console.log('changeQaStepKeepAlive', item)
//   })
// }
// setTimeout(() => {

//   const allRoutes = router.getRoutes()
//   const list = allRoutes.filter(item => item.name == 'QaFormStepTwo')
//   console.log('list', list)
//   list[0].tempkey += list[0].tempkey
//   //  const list =  routes.filter(item=>item.name =='QaFormStepTwo')
//   //  list[0].tempkey+=list[0].tempkey
//   // console.log('list', list)
// }, 10 * 1000);
// changeQaStepKeepAlive();



// export function resetRouter() {
//   router.getRoutes().forEach(route => {
//     console.log('resetRouter', route.name)
//     const name = route.name
//     if (name && router.hasRoute(name)) {
//       router.removeRoute(name)  // 移除现有路由
//     }
//   })
// }

// // 登录成功后
// export function onLoginSuccess() {
//   resetRouter()        // 清空旧路由
//   router.addRoute(...routes) // 动态添加登录后的路由
//   router.push({ name: 'Mine' })
//   // router.replace({ name: "Mine" });
// }

// 到我的页面
export const onLoginSuccess = () => {
  window.location.replace("/web/nbiz/cfilm/#/mine");
}







const letItGo = ['Dealer', 'DealerPc', 'DealerMobile', 'DealerPcMapTiler', 'DealerMapTiler', 'Scheme', 'Mine', 'DealerRegister', 'DealerUserRegister', 'UserRegister', 'ChangeLanguage', 'SchemeDetail', 'QaSearch', 'QaPublicQuery', 'QaPublicDetail', 'QaDetail', 'QrCode', 'SecurityCheck', 'MarkDown', 'Ppt', 'RoleSelect', 'MainBodyNextDealerRegister', 'MainBodyNextDealeNameRegister', 'AddressGeocode', 'PpfQuote', 'PpfQuotePc', 'CShop', 'COrderList', 'COrderDetail'];

// 主体名称页面
const mainbodyname = ['MainBodyDealerNameRegister', 'MainBodyDealerShopNameRegister', 'MainBodyServiceNameRegister', 'MainBodyNextDealerNameRegister', 'MainBodyDirectVendorNameRegister']



// 主体注册 
const mainbody = ['MainBodyDealerRegister', 'MainBodyServiceRegister', 'MainBodyDealerShopRegister', 'MainBodyDirectVendorRegister', 'RegisterAddressMapPicker'];

// 主体用户
const mainbodyuser = ['MainBodyDealerUserRegister', 'MainBodyServiceUserRegister', 'MainBodyDealerShopUserRegister', 'MainBodyNextDealerUserRegister', 'MainBodyDirectVendorUserRegister'];

const userregister = ['ConsumerUserRegister', 'ServiceProviderRegister'];

// 各个主体下的员工
const worker = ['QrCodeDealerUserRegister', 'QrCodeServiceUserRegister', 'QrCodeShopUserRegister', 'QrCodeSupplierUserRegister', 'QrCodeDirectVendorUserRegister']

const login = ['LoginRoleSelect', 'LoginRoleSelectRedesign'];

router.beforeEach((to, from, next) => {
  console.log('to.name', to.name)
  console.log('to', to)
  letItGo.push(...mainbodyname)
  letItGo.push(...mainbody)
  letItGo.push(...mainbodyuser)
  letItGo.push(...userregister)
  letItGo.push(...login)
  letItGo.push(...worker)
  if (letItGo.indexOf(to.name) === -1) {
    // load.small()
    if (isLogin() || to.name === 'Login') {
      next()
    } else {
      if (to.name === 'Shop') {
        next({ name: 'Login', query: { redirect: to.name } })
      } else if (to.name === 'QaForm' || to.name === 'QaList') {
        // 可能是在公众号的处理 
        if (to.query?.from == WX_OFFICIAL_ACCOUNT) {
          // 若当前是公众号的话 登录完成以后就直接返回到本页面 否则的话 都是返回到我的页面的 
          next({ name: 'Login', query: { redirect: to.name, path: to.path, from: WX_OFFICIAL_ACCOUNT, } })
        } else if (to.query?.lang) {
          next({ name: 'Login', query: { lang: to.query?.lang } })
        } else {
          next({ name: 'Login' })
        }

      } else if (
        to.name === 'ConsumerOrderDetail' ||
        to.name === 'ConsumerRetailerList' ||
        to.name === 'ConsumerProductSelect'
      ) {
        // 微信浏览器内：无论是否登录都放行进页面，由页面 onMounted 弹框引导去外部浏览器，
        // 避免「先登录 → 再引导去浏览器 → 又要重新登录」的二次登录
        if (/MicroMessenger/i.test(navigator.userAgent)) {
          next()
        } else {
          // 消费者下单/选品相关页面：登录/注册后需原路返回（redirect_full 保留完整 path+query）
          next({ name: 'Login', query: { redirect: to.name, redirect_full: to.fullPath } })
        }
      } else {
        next({ name: 'Login' })
      }
    }
  } else {
    // if (to.name == 'Ppt') {
    //   load.small()
    // } else {
    //   load.small()
    // }
    next()
  }
})



export default router
